var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-index-wrapper"},[_c('div',{staticClass:"swiper-box"},[_c('swiper-wrapper')],1),_c('banner'),_c('jinr-important'),_c('mid-tab'),_c('news'),_c('partner'),_c('Mfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }